import gql from 'graphql-tag';

export const SAMTYKKER_MUTATION = gql`
  mutation RegistrerBrukerSamtykke($input: BrukerSamtykker!) {
    registrerBrukerSamtykke(input: $input) {
      success
    }
  }
`;
